import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ detailedView?: boolean }>()(
  (theme, { detailedView }) => ({
    sectionHeading: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    sectionSubHeading: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.textField.main,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    noteContainer: {
      paddingTop: theme.spacing(2),
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
      width: '100%',
    },
    sectionContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
      width: '100%',
    },
    textWidth: {
      minWidth: '453px',
    },
    colorContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      width: '100%',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: theme.spacing(5),
    },
    colorInnerContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: theme.spacing(3),
      minWidth: '453px',
      width: '50%',
      marginTop: detailedView ? theme.spacing(2) : theme.spacing(0),
    },
    buttonColorInnerContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: theme.spacing(3),
      minWidth: '453px',
      width: '46%',
    },
    disableView: {
      display: 'felx',
      flexDirection: 'column',
      gap: theme.spacing(5),
    },
    fullWidth: {
      width: '100%',
    },
  })
)
